import { z } from 'zod';
/**
 * Contrats de la NOTE (rating), du COMPTEUR DE VUES et des COMMENTAIRES TYPÉS
 * (LOT 1 « données & tri »). Source unique front + back.
 *
 * DISTINCT des `notes` (fil passif inchangé) : un commentaire porte un CORPS texte
 * et, OPTIONNELLEMENT, un TYPE libre (libellé court). Le type n'est plus saisi par
 * l'UI (fil épuré) : le corps de mutation le rend facultatif (« absent → '' »,
 * normalisé dans le handler de route) ; la valeur stockée reste une chaîne (base
 * `citext NOT NULL`, `''` valide). Le filtre de recherche par type / l'endpoint
 * `comment-types` restent servis côté backend (API v1 lecture seule).
 *
 * - `ratingSchema` / `setRatingRequestSchema` : note 0..5 (0 = non noté).
 * - `assetCommentSchema`                       : un commentaire (lecture).
 * - `createCommentSchema` / `updateCommentSchema` : corps des mutations.
 * - `incrementViewResultSchema`                : réponse de l'incrément de vue.
 * - `commentTypesResultSchema`                 : liste des types (auto-complétion).
 */
/** Longueur maximale d'un TYPE de commentaire (libellé court). */
export const COMMENT_TYPE_MAX = 64;
/** Longueur maximale du CORPS d'un commentaire (aligné sur `NOTE_BODY_MAX`). */
export const COMMENT_BODY_MAX = 4000;
/** Note d'une photo : entier 0..5 ; `0` = « non noté ». */
export const ratingSchema = z.number().int().min(0).max(5);
/** Corps de `PATCH /api/assets/:id/rating`. */
export const setRatingRequestSchema = z.object({
    rating: ratingSchema,
});
/** Un commentaire typé du fil d'une photo (lecture). */
export const assetCommentSchema = z.object({
    id: z.uuid(),
    /** Type libre (insensible à la casse en base), auto-complété côté client. */
    type: z.string(),
    body: z.string(),
    /** Nom affiché de l'auteur (dérivé de `users.display_name`). */
    authorName: z.string(),
    createdAt: z.string().datetime({ offset: true }),
    updatedAt: z.string().datetime({ offset: true }),
});
/**
 * Corps de création d'un commentaire : corps non vide borné ; TYPE optionnel et
 * borné (l'UI ne le saisit plus → absent, normalisé « → '' » dans le handler).
 * SANS `.transform` (corps de route → `z.toJSONSchema` au boot, cf. garde
 * `route-json-schema.test.ts`).
 */
export const createCommentSchema = z.object({
    type: z.string().trim().max(COMMENT_TYPE_MAX).optional(),
    body: z.string().trim().min(1).max(COMMENT_BODY_MAX),
});
/** Corps de mise à jour d'un commentaire (mêmes contraintes que la création). */
export const updateCommentSchema = createCommentSchema;
/** Réponse de `POST /api/assets/:id/view` : nouveau compteur global. */
export const incrementViewResultSchema = z.object({
    viewCount: z.number().int().nonnegative(),
});
/**
 * Réponse de `GET /api/libraries/:id/comment-types` : les types déjà utilisés
 * (triés), pour l'auto-complétion côté client.
 */
export const commentTypesResultSchema = z.object({
    types: z.array(z.string()),
});
//# sourceMappingURL=comments.js.map